import Immutable from 'immutable';
import { createSelector } from 'reselect';

import { selectBibEntities, selectAvailabilityEntities } from 'app/selectors/EntitiesSelector';
import { selectCatalogBib } from '../catalogBibs/CatalogBibSelector';
import { selectManifestationsSummary } from '../catalogBibs/ManifestationsSelector';
import { selectReviewsForCurrentBib, selectAuthorNoteForCurrentBib } from './EvaluationSelector';

export const selectAnalyticsContextForCurrentBib = createSelector(
  [
    selectBibEntities,
    selectCatalogBib,
    selectManifestationsSummary,
    selectAvailabilityEntities,
    selectReviewsForCurrentBib,
    selectAuthorNoteForCurrentBib
  ],
  (bibs, catalogBib, manifestationsSummary, realtimeAvailabilities, reviews, authorNotes) => {
    if (!catalogBib) {
      return Immutable.Map();
    }

    const metadataId = catalogBib.get('metadataId');
    const bib = bibs.get(metadataId);

    return Immutable.Map({
      metadataId,
      format: bib.getIn(['briefInfo', 'format']),
      language: catalogBib.getIn(['brief', 'primaryLanguage']),
      description: !!catalogBib.getIn(['brief', 'description']),
      rating: bib.getIn(['briefInfo', 'rating', 'averageRating'], 0),
      groupKey: manifestationsSummary.get('groupKey'),
      manifestationCount: manifestationsSummary.get('editionsCount'),
      availabilityStatus: realtimeAvailabilities.getIn([metadataId, 'status'], ''),
      provider: bib.getIn(['policy', 'provider'], ''),
      content: bib.getIn(['briefInfo', 'contentType'], ''),
      audience: bib.getIn(['briefInfo', 'audiences', 0], ''),
      reviews: reviews.get('items').size > 0,
      authorNotes: authorNotes.length > 0
    });
  }
);

export default {
  selectAnalyticsContextForCurrentBib
};
